import { createColumnHelper } from '@tanstack/vue-table';
import { h } from 'vue'
import BasicStatus from '@/components/DataTable/BasicStatus';
import { BULK_DEAL_STATUS, BULK_HISTORY_STATUS } from '@/utils/enum/bulkActions';

const columnHelper = createColumnHelper();

function createColumn(accessor, header, size, cell = ({ getValue }) => getValue()) {
  return columnHelper.accessor(accessor, {
    header,
    cell,
    size,
  });
}

export function getUploadHistoryColumns() {
  return [
    createColumn('uploadFile', 'Dosya', 300),
    createColumn('uploadDate', 'Yükleme Tarihi', 176),
    createColumn('count', 'Yüklenen Ürün', 176),
    createColumn('successCount', 'Başarılı Yüklenen Ürün', 176),
    createColumn(
      'status',
      'Durum',
      176,
      ({ getValue }) =>
        h(BasicStatus, {
          type: getValue(),
        }),
    ),
    createColumn('failedCount', 'Hatalı Ürün', 106),
  ];
}

export function getDownloadHistoryColumns() {
  return [
    createColumn('templateFile', 'Şablon', 300),
    createColumn('docCreatedDate', 'Oluşturma Tarihi', 176),
    createColumn(
      'status',
      'Durum',
      176,
      ({ getValue }) =>
        h(BasicStatus, {
          type: getValue() === BULK_DEAL_STATUS.WAITING_FOR_DOWNLOAD
            ? BULK_HISTORY_STATUS.FINISHED_SUCCESS
            : getValue(),
        }),
    ),
    createColumn('id', 'İşlem', 106), // İndir butonu için ID'yi baz alıyoruz
  ];
}

export function getRejectReasonColumns() {
  return [
    createColumn('productCode','Ürün Kodu',246),
    createColumn('message', 'Hata Mesajı', 978),
  ];
}